import Logoimage from "../assets/logo.png"
const Logo =()=>{
    return(
        <div>
            <img  src={Logoimage} alt="logo"/>
        </div>
    )
}

export default Logo